import React, {useContext, useEffect, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import SystemContext from "../../SystemContext";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import AircraftLoadabilityStyles from "./styles/AircraftLoadabilityStyles";
import LoadabilityCheckSelector from "./components/LoadabilityCheckSelector";
import AircraftSideLoad from "./components/AircraftSideLoad";
import AircraftNoseLoad from "./components/AircraftNoseLoad";
import {useSettings} from "../../services/settings";
import {useQueryClient} from "react-query";

const AccessControl = require ("../../AccessControl");


function AircraftLoadabilityCheck(props) {
  const classes = makeStyles(AircraftLoadabilityStyles)();

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage STOCK"]);

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  const [aircraftType, setAircraftType] = useState("B744");
  const [sideLoadWidth, setSideLoadWidth] = useState(aircraftType === "B744" ? 1170 : `calc(100vw - 75px)`);

  useEffect(() => {
    const aircraftTypeSelected = (aircraftType) => {
      setAircraftType(aircraftType);
      setSideLoadWidth(aircraftType === "B744" ? 1170 : `calc(100vw - 75px)`)
    }


    if (eventBus) {
      eventBus.bind('AircraftTypeSelection.set', aircraftTypeSelected);
    }
    return () => {
      eventBus.unbind('AircraftTypeSelection.set', aircraftTypeSelected);
    }
  }, [eventBus]);

  const serverAddress = process.env.REACT_APP_SERVER_URL.substring(0, process.env.REACT_APP_SERVER_URL.lastIndexOf("/"));

  const queryClient = useQueryClient();
  const specialLoadsSettings = useSettings({queryClient, extraKeys: ["SPECIAL LOAD REQUEST", "PARAMETERS"]});
  let specialLoadsEmail = null;
  if (specialLoadsSettings && specialLoadsSettings.data && Array.isArray(specialLoadsSettings.data) && specialLoadsSettings.data.length > 0) {
    specialLoadsEmail = specialLoadsSettings.data[0]?.value?.notify;
  }

  return (isAuthenticated &&
    <div
      className="aircraftLoadabilityCheck"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="aircraftloadabilitycheck"
        pageName="Aircraft Loadability Check"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div className={classes.rooted} style={{width: "100%", height: 70, display: "block"}}>
        <div className={classes.rooted} style={{height: "100%", display: "block", marginLeft: 40, marginRight: 40, backgroundColor: "#ffffff"}}>
          <LoadabilityCheckSelector classes={classes} canEdit={canEdit}/>
        </div>
      </div>
      <div style={{height: 10}}></div>

      <div
        // className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4+16+68)}px)`, height: `calc(100vh - ${(99+2+10+57+4+16+68)}px)`}}
      >
        <div style={{display: "flex", width: "100%", position: "relative"}}>
          <div style={{display: "inline-flex", width: sideLoadWidth, MinWidth: sideLoadWidth, maxWidth: sideLoadWidth, height: "100%"}}>
            <AircraftSideLoad
              aircraftType={aircraftType}
              serverAddress={serverAddress}
              specialLoadsEmail={specialLoadsEmail}
              canEdit={canEdit}
              classes={classes}
              theme={theme}
              height={99+2+10+57+4+16+68}
            />
          </div>
          {aircraftType === "B744"
            ?
              <div style={{
                display: "inline-flex",
                position: "relative",
                width: `calc(100vw - 1265px)`,
                maxWidth: `calc(100vw - 1265px)`,
                marginLeft: 20,
                backgroundColor: "#ffffff"
              }}>
                <AircraftNoseLoad
                  serverAddress={serverAddress}
                  specialLoadsEmail={specialLoadsEmail}
                  canEdit={true}
                  classes={classes}
                  theme={theme}
                  height={99 + 2 + 10 + 57 + 4 + 16 + 68}
                />
              </div>
            :
            <></>
          }

        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default AircraftLoadabilityCheck;
